import * as eff from 'redux-saga/effects';

import {
  actionTypes,
  setProfileState,
} from '../actions';
import {
  getProfile,
} from '../selectors';
import {
  throwError,
} from './helpers';
import api from '../api';

export default function* announcementFlow() {
  function* createAnnouncement({ body, callbacks }): Generator<eff.Effect, void, any> {
    try {
      const results = yield eff.call(
        api.createAnnouncement,
        {
          body,
        },
      );

      callbacks?.setSubmitting?.(false);
      callbacks?.onSuccess?.(results);
    } catch (e) {
      callbacks?.setSubmitting?.(false);
      callbacks?.onError?.(e);
      yield eff.call(throwError, e);
    }
  }

  function* dismissAnnouncement({ id, callbacks }): Generator<eff.Effect, void, any> {
    try {
      const results = yield eff.call(
        api.dismissAnnouncement,
        {
          body: {
            announcement_id: id,
          },
        },
      );

      const dashboard = yield eff.select(
        getProfile('dashboard'),
      );

      yield eff.put(
        setProfileState({
          dashboard: {
            ...dashboard,
            announcement: null,
          },
        }),
      );

      callbacks?.onSuccess?.(results);
    } catch (e) {
      callbacks?.onError?.(e);
      yield eff.call(throwError, e);
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_CREATE_ANNOUNCEMENT, createAnnouncement);
  yield eff.takeEvery(actionTypes.REQUEST_DISMISS_ANNOUNCEMENT, dismissAnnouncement);
}
